import { stripMarketPathPrefix } from '@/shared/utils/urls';

export const addCountryParameter = (url: string, countryCode: string): string =>
  `${url}?country=${countryCode}`;

// `preservePath` is required rather than defaulted, because the two callers
// want opposite things and a silent default hid a regression once already:
// the footer switcher always carries the current path across (its long-
// standing behaviour), while the nudge only does so once
// `deep-link-equivalence.ts` has confirmed that path resolves on the target
// store, and otherwise sends the visitor to the target's homepage.
export const buildCountrySwitchUrl = (
  targetStoreEndpoint: string,
  countryCode: string,
  { preservePath }: { preservePath: boolean }
): string => {
  const targetUrl = new URL(
    addCountryParameter(targetStoreEndpoint, countryCode)
  );

  if (!preservePath) {
    return targetUrl.toString();
  }

  const finalUrl = new URL(window.location.href);
  finalUrl.hostname = targetUrl.hostname;
  // The market prefix is only meaningful on the source store - carried over
  // to another hostname it resolves to nothing and the visitor gets a 404.
  finalUrl.pathname = stripMarketPathPrefix(finalUrl.pathname);
  targetUrl.searchParams.forEach((value, key) =>
    finalUrl.searchParams.set(key, value)
  );

  return finalUrl.toString();
};
